<template>
  <div class="wrapper">
    <v-Header></v-Header>
    <el-container style="height:100%;">
      <v-Slidebar></v-Slidebar>
      <el-container class="main is-vertical">
        <div class="mainHead">
          <i class="fl" :class="iIcon" @click="changeCollapse"></i>
          <p class="fl">{{title}}</p>
        </div>
        <router-view/>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import vHeader from './Header'
import vSlidebar from './Slidebar'
export default {
  name: 'Home',
  components: {vHeader, vSlidebar},
  data () {
    return {
      iIcon: 'el-icon-s-fold'
    }
  },
  computed: {
    title () {
      return this.$store.state.headTitle
    }
  },
  created () {
    if (this.$route.name === 'Overview') {
      this.$store.state.headTitle = '概况'
    } else {
      this.$store.state.headTitle = '详细信息'
    }
    this.getIsLogin()
  },
  methods: {
    changeCollapse () {
      this.$store.state.isCollapse = !this.$store.state.isCollapse
      if (this.$store.state.isCollapse) {
        this.iIcon = 'el-icon-s-unfold'
      } else {
        this.iIcon = 'el-icon-s-fold'
      }
    },
    // 判断是否登陆
    getIsLogin () {
      this.$http.post('/PublicOperation/GetIsLogin', {}).then(res => {
        if (res.body.Success && res.body.Value !== -1) {
          this.$store.state.schoolID = res.body.Value
        } else {
          window.location.href = '/Login.aspx'
        }
      })
    }
  }
}
</script>

<style scoped>
  .wrapper{
    height:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Home.vue